/*import React from 'react';
import ChatApp from './components/ChatApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <ChatApp />
    </div>
  );
}

export default App;*/

import React from 'react';
import ChatPage from './pages/ChatPage';

function App() {
  return (
    <div className="App">
      <ChatPage />
    </div>
  );
}

export default App;